import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { useCallback } from 'react'
import {
  googleUserAtom,
  getTabValuesByTitle,
  listTabs,
} from 'infrastructure/googleDrive'

function isAuthError(err: unknown): boolean {
  if (err instanceof Error) {
    return err.message.includes('HTTP 401') || err.message.includes('HTTP 403')
  }
  return false
}

export function useListTabs() {
  const [googleUser, resetUser] = useAtom(googleUserAtom)

  return useCallback(
    async (fileId: string) => {
      if (!googleUser.credential?.accessToken) return
      try {
        return await listTabs(fileId, googleUser.credential.accessToken)
      } catch (err) {
        if (isAuthError(err)) {
          resetUser()
          return
        }
        throw err
      }
    },
    [googleUser, resetUser],
  )
}

export function useGetTabValues() {
  const [googleUser, resetUser] = useAtom(googleUserAtom)

  return useCallback(
    async (p: { spreadsheetId: string | number; title: string }) => {
      if (!googleUser.credential?.accessToken) return
      try {
        return await getTabValuesByTitle({
          ...p,
          accessToken: googleUser.credential.accessToken,
        })
      } catch (err) {
        if (isAuthError(err)) {
          resetUser()
          return
        }
        throw err
      }
    },
    [googleUser, resetUser],
  )
}
